import { render, staticRenderFns } from "./autocollection.vue?vue&type=template&id=ae015632&"
import script from "./autocollection.vue?vue&type=script&lang=js&"
export * from "./autocollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports